import { authService } from 'spec';
import { useState } from 'react';
import { formatQueryString } from '../utils/Utils';

const hostName = window.paths.bhn;

export const aryGetDataExpectTypes = {
  file: 'file',
  json: 'json'
};

const useAryGetData = (api, options) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState('');
  const [error, setError] = useState('');

  const expect = options?.expect || aryGetDataExpectTypes.json;

  async function getData(queryStrings) {
    setLoading(true);

    const token = await authService.getAccessToken();
    const response = await fetch(
      `${options?.hostName || hostName}${api}${formatQueryString(
        queryStrings
      )}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    setLoading(false);

    let receivedData;
    let errorResponse;
    if (response.status === 200) {
      if (expect === aryGetDataExpectTypes.file) {
        receivedData = await response.blob();
      } else {
        receivedData = await response.json();
      }
      errorResponse = null;
    } else {
      receivedData = null;
      errorResponse = await response.json();
    }
    setData(receivedData);
    setError(errorResponse);

    return receivedData;
  }

  return [getData, { data, loading, error }];
};

export default useAryGetData;
